module.exports = __webpack_public_path__ + "img/mastercard.49be6127.svg";